<template>
  <b-modal style="height: 100%" b-modal ref="mdlContabilitaDocumentiCollegatiModal" size="lg"
    @shown="onShownModalContabilitaDocumenti">
    <label class="sa-label-data">Seleziona Documenti Collegati</label>
    <ul v-if="causaleDocumento">
      <li style="display: inline; margin: 5px" v-for="causale in causaleDocumento.documentiCollegati" :key="causale.id">
        <label :class="{ 'sa-badge': true }" v-html="getCausaleDocumentoDescrizione(causale)"></label>
      </li>
    </ul>
    <div class="sa-list-component">
      <div class="sa-list-component-body">
        <ContabilitaDocumentiListComponent ref="cmpContabilitaDocumentiList"
          @afterLoadData="ContabilitaDocumentiListAfterLoadData" :actions="false" @rowSelected="onRowSelected"
          :selectable="true" />
      </div>
    </div>
    <template #modal-footer>
      <b-button size="md" variant="outline-danger" @click="onCLickAnnulla()"> Annulla </b-button>
      <b-button :disabled="!rowsDocumentiSelected.length > 0" variant="outline-primary"
        @click="onClickSelezionaDocumenti"> Conferma Selezione </b-button>
    </template>
  </b-modal>
</template>
<script>
import axios from "axios";
import ContabilitaMixin from "../mixins/ContabilitaMixin";
import ContabilitaDocumentiListComponent from "./ContabilitaDocumentiListComponent.vue";
import moment from "moment";
export default {
  mixins: [ContabilitaMixin],
  components: { ContabilitaDocumentiListComponent },
  data() {
    return {
      fields: [
        {
          label: "N.",
          key: "index",
          thStyle: "width: 3rem",
        },
      ],
      arraySelezionati: {
        tipiDocumentoSelezionati: [],
      },
      filtro: {
        idTipoDocumenti: [],
        soggettoCognome: null,
        soggettoNome: null,
        soggettoId: null,
      },
      rowsDocumentiSelected: [],
      documentiSelezionatiArrayAssociativo: {},
      perPage: 10,
      currentPage: 1,
      causaleDocumento: null,
      documentiCollegati: [],
      jsonData: { codiceStruttura: null, documentiCollegati: [] },
      listKey: 0,
      pathResource: "/contabilitadocumenticollegati",
    };
  },
  mounted() { },
  methods: {
    init(jsonData, causaleDocumento) {
      this.jsonData = jsonData;
      if (jsonData.id) {
        this.loadDataDocumentiCollegati(jsonData.id);
      } else {
        if (causaleDocumento != null) {
          this.causaleDocumento = causaleDocumento;
          this.listKey++;
        }
      }
      this.loadDataDefault();
      this.open();
    },
    ContabilitaDocumentiListAfterLoadData() {
      this.$refs.cmpContabilitaDocumentiList.setDocumentiCollegati(this.jsonData.documentiCollegati);
    },

    loadDataDefault() {
      this.contabilitaTipoDocumentoLoadData(this.jsonData.strutturaCodice);
    },

    open() {
      this.$refs.mdlContabilitaDocumentiCollegatiModal.show();
    },
    hide() {
      this.$refs.mdlContabilitaDocumentiCollegatiModal.hide();
    },
    onRowSelected(array) {
      this.rowsDocumentiSelected = array;
      let arraytmp = {};
      array.forEach((element) => {
        arraytmp[element.id] = null;
      });
      for (let documentoSelezionato of array) {
        if (!this.documentiSelezionatiArrayAssociativo[documentoSelezionato.id]) {
          let link = process.env.VUE_APP_PATH_API + "/contabilitadocumentorighe?idDocumento=" + documentoSelezionato.id;
          axios
            .get(link)
            .then((response) => {
              let righe = response.data.data.list;
              righe.forEach(e => {
                e.primaryKey = null;
                e.idDocumento = null;
              })
              this.documentiSelezionatiArrayAssociativo[documentoSelezionato.id] = righe;
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
      let keysAss = Object.keys(this.documentiSelezionatiArrayAssociativo);
      let keysTmp = Object.keys(arraytmp);
      keysAss.forEach((key) => {
        if (!keysTmp.includes(key)) {
          delete this.documentiSelezionatiArrayAssociativo[key];
        }
      });
    },
    onCLickAnnulla() {
      this.hide();
    },
    isActiveTipologia(causale) {
      return this.arraySelezionati.tipiDocumentoSelezionati.indexOf(causale.id) != -1;
    },
    onShownModalContabilitaDocumenti() {
      let tipiDocumenti = this.getCausaliDocumenti();
      this.$refs.cmpContabilitaDocumentiList.loadData({ idTipoDocumento: tipiDocumenti });
    },
    getCausaliDocumenti() {
      let returnValue = "";
      for (let doc of this.causaleDocumento.documentiCollegati) {
        returnValue += doc.idTipoDocumento + "#";
      }
      return returnValue;
    },

    onClickSelezionaDocumenti() {
      let arrayRiferimenti = [];
      if (this.rowsDocumentiSelected.length > 0) {
        for (let documento of this.rowsDocumentiSelected) {
          let obj = {
            idDocumento: null,
            idDocumentoRiferimento: documento.id,
            documentoDescrizione: `${documento.tipoDocumentoDescrizione}`,
            documentoRiferimentoDescrizione: `${documento.tipoDocumentoDescrizione} N. ${documento.documentoNumero} Del ${moment(documento.documentoData).format("DD/MM/YYYY")}`,
          };
          arrayRiferimenti.push(obj);
        }
      }
      this.$emit("updateDocumentiRiferimento", arrayRiferimenti, this.documentiSelezionatiArrayAssociativo);
    },

    loadDataDocumentiCollegati(id) {
      console.log("Documenti Collegati: " + id);
    },
    loadDataDocumentiCollegatiSuccess() { },
    loadDataDocumentiCollegatiError() { },
    getCausaleDocumentoDescrizione(causale) {
      console.log(causale);

      let icon = causale.obbligatorio ? '<i style="color:red" size="lg" class="fas fa-exclamation"></i>' : "";

      let span = `${this.getTipoDocumentoDescrizione(causale.idTipoDocumento)} ${icon}`;

      return span;
    },
    onClickTipologiaDocumento(causale) {
      if (this.arraySelezionati.tipiDocumentoSelezionati.indexOf(causale.id) == -1) {
        this.arraySelezionati.tipiDocumentoSelezionati.push(causale.id);
      } else {
        this.arraySelezionati.tipiDocumentoSelezionati.splice(this.arraySelezionati.tipiDocumentoSelezionati.indexOf(causale.id), 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ft-active-class {
  border: 1px solid #36b1cf !important;
}

.sa-badge {
  cursor: pointer;
}
</style>